import costCenterEditComponent from './cost_center.edit.component';

let costCenterEditModule = angular.module('costCenterEdit', [])
.component('costCenterEdit', costCenterEditComponent)
.name;

export default costCenterEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/edit/index.js